import { AppTheme } from "@/theme";
import { useMediaQuery, useTheme } from "@mui/material";

export function useIsMobile() {
  const theme: AppTheme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}
